module.exports = __webpack_public_path__ + "/bundle/asset/U2_06-213aefa2a00cb474785fe71752c142f8.gif";